import { render, staticRenderFns } from "./NewOQCExamine.vue?vue&type=template&id=51fc0b58&scoped=true"
import script from "./NewOQCExamine.vue?vue&type=script&lang=js"
export * from "./NewOQCExamine.vue?vue&type=script&lang=js"
import style0 from "./NewOQCExamine.vue?vue&type=style&index=0&id=51fc0b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc0b58",
  null
  
)

export default component.exports